export default __webpack_public_path__ + "static/media/schmerztherapie_01.be3a126b.png";